export const offerIncludes: string[] = [
  '7 Complete Professional Volumes',
  '150 Ready-to-Use Massage Sessions',
  'Applied Anatomy System with regional muscle maps',
  'Movement references and palpation orientation',
  'Technique sequences for every body region',
  'Client assessment and session planning systems',
  'Positioning and pressure guidance',
  'Special client adaptations + 20 adapted session plans',
  'Advanced professional practice and teaching resources',
  '75 Massage Session Add-Ons & Mini Protocols',
  '50 Client Aftercare & Education Guides',
  'Mobile Massage Professional Setup Guide',
  'Massage Practice Growth & Client Retention Guide',
  'Massage Therapist Career Longevity Guide',
  'Printable professional resources',
  '7-Day Money-Back Guarantee',
  'Instant digital access',
]

export const everythingIncluded: string[] = [
  'Volume 1: Massage Therapy Foundations & Professional Practice',
  'Volume 2: Applied Anatomy, Muscles & Movement',
  'Volume 3: Essential Massage Techniques & Technique Sequences',
  'Volume 4: Client Assessment, Session Planning & Adaptation',
  'Volume 5: 150 Ready-to-Use Massage Sessions',
  'Volume 6: Special Populations & Advanced Session Adaptations',
  'Volume 7: Advanced Practice, Teaching & Client Experience',
  '150 Ready-to-Use Massage Sessions',
  'Applied Anatomy References',
  'Muscle & Movement Maps',
  'Palpation Orientation',
  'Technique Sequences',
  'Session Planning Systems',
  'Client Adaptations',
  'Bonus 1: 75 Massage Session Add-Ons & Mini Protocols',
  'Bonus 2: 50 Client Aftercare & Education Guides',
  'Bonus 3: Mobile Massage Professional Setup Guide',
  'Bonus 4: Massage Practice Growth & Client Retention Guide',
  'Bonus 5: Massage Therapist Career Longevity Guide',
  'Instant Digital Access',
  '7-Day Money-Back Guarantee',
]

export const painCosts: string[] = [
  'Hours spent thinking about or preparing upcoming sessions',
  'Repeating the same routine because it feels familiar',
  'Hesitating over technique order and session flow',
  'Feeling less prepared than you want when the client arrives',
  'Difficulty adapting sessions when client needs change',
  'Scattered notes, references, and resources everywhere',
  'Knowing anatomy but not always knowing how to apply it',
  'Wasting personal time searching for ideas and structure',
  'Relying too heavily on improvisation during appointments',
]

export const noMore: string[] = [
  'No more wondering what to do next',
  'No more repeating the same routine with every client',
  'No more scattered notes and disconnected references',
  'No more creating every session from zero',
  'No more guessing how to adapt the same approach to different clients',
  'No more wasting preparation time searching for ideas',
  'No more treating anatomy, techniques, and planning as separate pieces',
  'No more walking into an appointment wishing you had prepared more',
]
